module.exports = __webpack_public_path__ + "img/trans-active.f5d8817d.svg";